// i18n
import 'src/locales/i18n';
import 'simplebar-react/dist/simplebar.min.css';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import 'react-quill/dist/quill.snow.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-lazy-load-image-component/src/effects/blur.css';
// ----------------------------------------------------------------------
// routes
import Router from 'src/routes/sections';
import ThemeProvider from 'src/theme';
import { LocalizationProvider } from 'src/locales';
import { useScrollToTop } from 'src/hooks/use-scroll-to-top';
import ProgressBar from 'src/components/progress-bar';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import SnackbarProvider from 'src/components/snackbar/snackbar-provider';
import { SettingsProvider, SettingsDrawer } from 'src/components/settings';
import { CheckoutProvider } from 'src/sections/checkout/context';
import { AuthProvider, AuthConsumer } from 'src/auth/context/jwt';
import { GanttProvider } from './contexts/gantt-chart/gantt-provider';
import { NavSettingsProvider } from './contexts/nav-bar/nav-setting-context';
import { ProfileProvider } from './components/profile/context';
// ----------------------------------------------------------------------
export default function App() {
  const charAt = `

  ░░░    ░░░
  ▒▒▒▒  ▒▒▒▒
  ▒▒ ▒▒▒▒ ▒▒
  ▓▓  ▓▓  ▓▓
  ██      ██

  `;

  console.info(`%c${charAt}`, 'color: #5BE49B');
  useScrollToTop();
  return (
    <AuthProvider>
      <GanttProvider>
        <LocalizationProvider>
          <SettingsProvider
            defaultSettings={{
              themeMode: 'light',
              themeDirection: 'ltr',
              themeContrast: 'default',
              themeLayout: 'vertical',
              themeColorPresets: 'default',
              themeStretch: false,
            }}
          >
            <ThemeProvider>
              <MotionLazy>
                <SnackbarProvider>
                  <NavSettingsProvider>
                    <CheckoutProvider>
                      <ProfileProvider>
                        <SettingsDrawer />
                        <ProgressBar />
                        <AuthConsumer>
                          {/* <DashboardLayout> */}
                          <Router />
                          {/* </DashboardLayout> */}
                        </AuthConsumer>
                      </ProfileProvider>
                    </CheckoutProvider>
                  </NavSettingsProvider>
                </SnackbarProvider>
              </MotionLazy>
            </ThemeProvider>
          </SettingsProvider>
        </LocalizationProvider>
      </GanttProvider>
    </AuthProvider>
  );
}
